import type JSZip from 'jszip';
import { csvCell } from '../weighting';
import { DataDownloadFile, DataExport, cellText, fileBaseName } from './data-export';
import { datamapText, decipherBlocks } from './decipher-datamap';

/** U+FEFF, the byte order mark. Spelled out because the character itself is invisible in an editor. */
export const BOM = String.fromCharCode(0xfeff);

/**
 * Decipher's CSV download: the responses as CSV and `datamap.txt` beside them in one zip, which is
 * what a Decipher CSV upload asks for back.
 *
 * Codes as Decipher writes them, and blank where the respondent wasn't shown the question. The BOM is
 * for Excel, which otherwise reads UTF-8 as the local code page; the upload ignores it.
 */
export function decipherCsv(data: DataExport): string {
  const rows = data.records.map(record =>
    data.columns.map(column => csvCell(cellText(data, record, column))).join(','));
  return BOM + [data.columns.map(csvCell).join(','), ...rows].join('\r\n') + '\r\n';
}

export async function decipherCsvZip(data: DataExport, csvName: string): Promise<JSZip> {
  const { default: Zip } = await import('jszip');
  const zip = new Zip();
  zip.file(csvName, decipherCsv(data));
  zip.file('datamap.txt', datamapText(decipherBlocks(data)));
  return zip;
}

export async function decipherCsvDownload(data: DataExport, reportName: string): Promise<DataDownloadFile> {
  const name = fileBaseName(reportName);
  const zip = await decipherCsvZip(data, `${name}.csv`);
  return { file: await zip.generateAsync({ type: 'blob', compression: 'DEFLATE' }), fileName: `${name} data.csv.zip` };
}
